import { cn } from '@/lib/utils';

type Props = {
  unread: boolean;
  className?: string;
  label?: string;
};

/** Gmail-style unread indicator — blue dot before the star column. */
export function ApplicationUnreadDot({ unread, className, label = 'Unread application' }: Props) {
  if (!unread) {
    return <span className={cn('inline-block h-2 w-2 shrink-0', className)} aria-hidden />;
  }

  return (
    <span
      className={cn(
        'inline-block h-2 w-2 shrink-0 rounded-full bg-primary',
        className,
      )}
      role="img"
      aria-label={label}
      title={label}
    />
  );
}
